import { Box, Container, Theme } from '@mui/material';
import { IMainLayoutProps, MAIN_LAYOUT_MOBILE_PADDING } from '@myhrbox/myhrbox-frontend-core';
import { ElementType } from 'react';

const HeaderlessMainLayout = ({ AuthContainer, children, sx }: IMainLayoutProps) => {
  const PageContainer = (AuthContainer ?? Container) as ElementType;
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#F6F8FF',
        minHeight: '100vh',
        p: { xs: `${MAIN_LAYOUT_MOBILE_PADDING}px`, sm: 0 },
        ...sx,
      }}>
      <Box
        component='main'
        sx={{
          flexGrow: 1,
          minHeight: 0,
          overflowY: 'auto',
          display: 'flex',
          flexDirection: 'column',
        }}>
        <PageContainer
          maxWidth='xl'
          sx={(theme: Theme) => ({
            mt: 4,
            pb: 4,
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            justifyContent: 'flex-start',
            position: 'relative',
            overflow: 'hidden',
            [theme.breakpoints.down('sm')]: {
              px: 0,
            },
          })}>
          {children}
        </PageContainer>
      </Box>
    </Box>
  );
};

export default HeaderlessMainLayout;
